
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/get-started/register",
      function () {
        return require("private-next-pages/[brand]/get-started/register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/get-started/register"])
      });
    }
  